<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']"
  titleText="i18n.domain.problem-report-administration.title"></app-title-bar>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
            class="grid-with-toolbar grid-with-footer"
            width="100%"
            rowHeight="38"
            [dataSource]="data"
            [allowSorting]="true"
            [allowFiltering]="true"
            [filterSettings]="filterSettings"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [allowResizing]="true"
            [editSettings]="editSettings"
            [searchSettings]="searchOptions"
            [showColumnChooser]="true"
            [toolbar]="toolbar"
            (actionBegin)="actionBegin($event)"
            (actionComplete)="actionComplete($event)">
    <e-columns>
      <e-column field="id"
                [visible]="false"
                headerText="ID"
                [isPrimaryKey]="true"
                width="80"></e-column>
      <e-column field="user.firstname"
                headerText="{{'i18n.shared.fields.firstname' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="150"></e-column>
      <e-column field="user.lastname"
                headerText="{{'i18n.shared.fields.lastname' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="150"></e-column>
      <e-column field="platform"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.platform' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="120"></e-column>
      <e-column field="origin"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.origin' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="130">
        <ng-template #template let-data>
          <span>{{ ProblemReportOrigin[data.origin] }}</span>
        </ng-template>
      </e-column>
      <e-column field="problemMessage"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.problem-message' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="300"></e-column>
      <e-column field="createdOn"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.created-on' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm"
                clipMode="EllipsisWithTooltip"
                width="160"></e-column>
      <e-column field="model"
                [visible]="false"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.model' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="150"></e-column>
      <e-column field="manufacturer"
                [visible]="false"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.manufacturer' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="150"></e-column>
      <e-column field="deviceName"
                [visible]="false"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.device-name' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="150"></e-column>
      <e-column field="versionString"
                [visible]="false"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.version-string' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="150"></e-column>
      <e-column field="idiom"
                [visible]="false"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.idiom' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="120"></e-column>
      <e-column field="deviceType"
                [visible]="false"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.device-type' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="120"></e-column>
      <e-column field="userId"
                [visible]="false"
                headerText="{{'i18n.domain.problem-report-administration.overview.fields.user-id' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="200"></e-column>
      <e-column headerText=""
                [commands]="gridCommands"
                width="145px"
                [showInColumnChooser]="false"></e-column>
    </e-columns>
    <ng-template #editSettingsTemplate
                 let-data>
      <app-problem-report-detail [report]="data"></app-problem-report-detail>
    </ng-template>
  </ejs-grid>
</div>
